export const filterObjectArray = (array, property) => {
  const seen = new Set();
  return array.filter(obj => {
    const value = obj[property];
    if (!seen.has(value)) {
      seen.add(value);
      return true;
    }
    return false;
  });
};

export const formatInviteStatus = ({ status, expirationDate }) => {
  if (!expirationDate || !status) return '';
  if (status === 'accepted') return 'Accepted';

  const expirationDateObject = new Date(expirationDate);
  const isExpired = expirationDateObject.getTime() < new Date().getTime();

  return isExpired ? 'Expired' : 'Pending';
};

export const createSearchParamsString = object => {
  if (!object || !Object.values(object).length) return '';

  const searchParams = new URLSearchParams();

  Object.entries(object).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  return '?' + searchParams.toString();
};

export const getTagDetails = (selectedOptions, addedTag) => {
  const tagNames = [...selectedOptions.map(tag => tag.name), addedTag.name];
  const tagIds = [...selectedOptions.map(tag => tag.id), addedTag.id];
  return [tagNames, tagIds];
};

export const numDigitsCount = number =>
  (Math.log10((number ^ (number >> 31)) - (number >> 31)) | 0) + 1;

export function formatBytes(bytes) {
  if (typeof bytes !== 'number' || bytes < 0) {
    return '0 KB';
  }
  const mb = 1024;
  const kilobytes = bytes / mb;
  const megabytes = kilobytes / mb;

  if (megabytes >= 1) {
    return `${megabytes.toFixed(2)} MB`;
  } else {
    return `${kilobytes.toFixed(2)} KB`;
  }
}

export const splitHighlight = (text, searchValue) => {
  if (typeof text !== 'string' || !text) {
    return [];
  }

  const escapedSearchValue = typeof searchValue === 'string' ? escapeRegExp(searchValue.trim()) : '';
  if (!escapedSearchValue) {
    return [{ text, match: false }];
  }

  // A capturing split interleaves matches at the odd indices, so parity has to be read before the
  // empty segments a leading/trailing/adjacent match produces are dropped.
  return text
    .split(new RegExp(`(${escapedSearchValue})`, 'gi'))
    .map((part, index) => ({ text: part, match: index % 2 === 1 }))
    .filter(part => part.text);
};

export const formatLabelPlusMore = (primary, total) => {
  const n = typeof total === 'number' ? total : 0;
  if (n <= 0) {
    return 'None';
  }
  const label = typeof primary === 'string' ? primary.trim() : '';
  if (!label) {
    return String(n);
  }
  if (n <= 1) {
    return label;
  }
  return `${label} + ${n - 1} more`;
};

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Shortens any long hex run in a string so SHA-256 and TBS hashes stay readable inline. Keeps only
// the leading characters, which is the part users compare against.
export const abbreviateHashes = value =>
  String(value ?? '').replace(/\b[0-9a-f]{32,}\b/gi, hash => `${hash.slice(0, 12)}…`);

export const customBoolean = value => {
  if (typeof value === 'string' && value.toLowerCase() === 'false') {
    return false;
  }
  return Boolean(value);
};
